import { IProductCore } from "../types/IProductCore";
import axiosInstance from "../../setupAxios";

export class ProductRequest {
    public static getCueSheetEnabledProduct(id1: string, id2: string): Promise<IProductCore> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .post('/Product/CommonCuesheet', {
                    id1: id1,
                    id2: id2
                })
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    } else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}